<template>
  <module-page v-bind="pageParams">
    <v-layout row wrap>
      <v-flex xs12>
        <v-tabs class="page__tabs" hide-slider>
          <v-tab
            :key="i"
            :to="tab.value"
            v-for="(tab, i) in pageParams.tabs"
            :active-class="`white--text ${
              hasLateSlips ? 'error--background' : 'financial--background'
            }`"
          >
            {{ !mobile ? tab.title : tab.titleMobile }}
            <i
              v-if="hasLateSlips && tab.icon"
              :class="`${tab.icon} side-text--icon`"
            />
          </v-tab>
        </v-tabs>
        <div class="payment-slip-in-delay__description">{{ description }}</div>
        <screen-loading v-if="loadingItems"></screen-loading>
        <div v-else-if="error" class="empty-state">
          {{ $t('responses.error') }}
        </div>
        <div v-else>
          <template
            v-if="!hasLateSlips && Object.keys(solicitations).length === 0"
          >
            <empty-state-card :icon="enums.paymentSlipWaitingState.icon">
              <div
                slot="message"
                v-html="$t('pages.paymentSlip.emptyLateSlips')"
              />
            </empty-state-card>
          </template>
          <template
            v-else-if="
              debitBlock ||
              (!inDelaySolicitationAllowed && !hasSolicitationsInProgress)
            "
          >
            <empty-state-card icon="alert">
              <div slot="message" class="error--color">
                <p class="waiting-state__title">
                  <span>
                    <b>{{ $t('pages.paymentSlip.operationNotAllowed') }}</b>
                  </span>
                </p>
                <p class="waiting-state__text">
                  <span>{{
                    $t('pages.paymentSlip.partialSlipWarningSubTitle')
                  }}</span>
                </p>
                <p class="waiting-state__text">
                  <router-link
                    v-if="ticketCrmEnabled"
                    :to="{ name: 'ticketForm' }"
                    class="error--color font-weight-bold"
                    tag="a"
                  >
                    <u>{{ $t('pages.paymentSlip.supportLink') }}</u>
                  </router-link>
                </p>
              </div>
            </empty-state-card>
          </template>
          <template v-else-if="parcelTypesNotValid">
            <empty-state-card :icon="enums.paymentSlipWaitingState.icon">
              <div slot="message" class="error--color">
                <p class="payment-slip__late__info late">
                  <i class="payment-slip__late__icon bexsicon-alert icon"></i>
                  <span
                    >{{ $t('pages.paymentSlip.notPayableLateMessage') }}
                    <router-link
                      v-if="ticketCrmEnabled"
                      :to="{ name: 'ticketForm' }"
                      class="error--color font-weight-bold"
                      tag="a"
                    >
                      <u>{{ $t('pages.paymentSlip.supportLink') }}</u>
                    </router-link>
                  </span>
                </p>
              </div>
            </empty-state-card>
          </template>
          <template v-else>
            <empty-state-card messagePadding="2%" messageClass="xs12 md12 lg12">
              <template slot="message">
                <span class="payment-slip-in-delay__febraban font-weight-bold">
                  {{ latePaymentSlipTooltip }}
                </span>
              </template>
            </empty-state-card>
            <span v-for="(contract, i) in allowedContracts" :key="i">
              <v-card
                v-if="
                  slips[contract.id] === null ||
                  slips[contract.id] ||
                  solicitations[contract.id]
                "
                class="mt-2 mb-2"
              >
                <v-card-title class="pt-headline financial--color">{{
                  getContractTitle(contract)
                }}</v-card-title>
                <screen-loading
                  v-if="slips[contract.id] === null"
                  margin="20px 25%"
                ></screen-loading>
                <v-card-text v-else>
                  <p
                    v-if="
                      config.texts.lateSlipDetachedContractMessage &&
                      contract.type === enums.contractValues.detached
                    "
                    class="payment-slip-in-delay__description"
                    style="margin: 2px 18px"
                  >
                    {{ config.texts.lateSlipDetachedContractMessage }}
                    <router-link
                      v-if="ticketCrmEnabled"
                      style="color: var(--financial-color); font-weight: bold"
                      :to="{ name: 'ticketForm' }"
                      tag="a"
                    >
                      <u>{{ $t('pages.paymentSlip.supportLink') }}</u>
                    </router-link>
                  </p>

                  <empty-state-card
                    v-if="
                      !inDelaySolicitationAllowed &&
                      selectedStep[contract.id] === '1'
                    "
                    icon="alert"
                  >
                    <div slot="message" class="error--color">
                      <p class="waiting-state__title">
                        <span>
                          <b>{{
                            $t('pages.paymentSlip.operationNotAllowed')
                          }}</b>
                        </span>
                      </p>

                      <p class="waiting-state__text">
                        <span>{{
                          $t('pages.paymentSlip.partialSlipWarningSubTitle')
                        }}</span>
                      </p>

                      <p class="waiting-state__text">
                        <router-link
                          v-if="ticketCrmEnabled"
                          class="error--color font-weight-bold"
                          :to="{ name: 'ticketForm' }"
                          tag="a"
                        >
                          <u>{{ $t('pages.paymentSlip.supportLink') }}</u>
                        </router-link>
                      </p>
                    </div>
                  </empty-state-card>
                  <div v-else class="table-stepper-container">
                    <template
                      v-if="
                        (!solicitations[contract.id] ||
                          solicitations[contract.id].length == 0) &&
                        (!slips[contract.id] || slips[contract.id].length == 0)
                      "
                    >
                      <empty-state-card
                        :icon="enums.paymentSlipWaitingState.icon"
                      >
                        <div slot="message">
                          <p class="waiting-state__title">
                            <span>
                              <b>{{ pageParams.emptyState.late }}</b>
                            </span>
                          </p>
                        </div>
                      </empty-state-card>
                    </template>
                    <table-stepper
                      v-else-if="!systemDischarge[contract.id]"
                      v-model="selectedStep[contract.id]"
                      v-bind="enums.paymentSlipRequestSteps"
                      :no-data-text="pageParams.emptyState.late"
                      :items="
                        solicitations[contract.id] &&
                        solicitations[contract.id].length > 0
                          ? solicitations[contract.id]
                          : slips[contract.id] || []
                      "
                      :loading="loadingApp"
                      :headers="
                        selectedStep[contract.id] === '1'
                          ? firstStepHeaders
                          : headers
                      "
                      :mobileHeaders="
                        selectedStep[contract.id] === '1'
                          ? firstStepMobileHeaders
                          : mobileHeaders
                      "
                      @updateSelected="
                        (v) => {
                          selected[contract.id] = v;
                        }
                      "
                      buttonClass="white--text financial--background"
                      totalKey="discountedValue"
                      totalLabel="Total"
                      sort-icon="bexsicon-down"
                      itemKey="id"
                      :buttonText="enums.paymentSlipRequestButtonText"
                      @buttonClicked="solicitateSlip(contract.id)"
                      :buttonLoading="loadingSolicitation"
                      :activeClass="`
                      financial--background
                      financial--border-color
                      all--white`"
                    >
                      <template slot="firstStepTableItems" slot-scope="props">
                        <td class="text-xs-center">
                          {{ formatDate(props.item.expirationDate) }}
                        </td>
                        <td class="text-xs-center bold--text">
                          {{ formatMoney(props.item.discountedValue) }}
                        </td>
                        <td v-if="!mobile" class="text-xs-center"></td>
                      </template>
                      <template slot="secondStepTableItems">
                        <empty-state-card
                          :icon="enums.paymentSlipWaitingState.icon"
                        >
                          <div slot="message">
                            <p
                              :class="`waiting-state__title ${
                                solicitationErrors[contract.id]
                                  ? 'error--text'
                                  : ''
                              }`"
                            >
                              {{
                                $t(
                                  enums[
                                    solicitationErrors[contract.id]
                                      ? 'paymentSlipError'
                                      : 'paymentSlipWaitingState'
                                  ].title
                                )
                              }}
                            </p>
                            <p class="waiting-state__text">
                              {{
                                $t(
                                  enums[
                                    solicitationErrors[contract.id]
                                      ? 'paymentSlipError'
                                      : 'paymentSlipWaitingState'
                                  ].firstLine,
                                  { slipTimeoutHours }
                                )
                              }}
                              <router-link
                                v-if="
                                  ticketCrmEnabled &&
                                  solicitationErrors[contract.id]
                                "
                                :to="{ name: 'ticketForm' }"
                                tag="a"
                              >
                                <u>{{ enums.paymentSlipError.link }}</u>
                              </router-link>
                            </p>
                          </div>
                        </empty-state-card>
                      </template>
                      <template slot="thirdStepTableItems" slot-scope="props">
                        <td class="text-xs-center">
                          {{ formatDate(props.item.expirationDate) }}
                        </td>
                        <td class="text-xs-center bold--text">
                          {{ formatMoney(props.item.paymentTotal) }}
                        </td>
                        <td class="text-xs-center">
                          <PaymentButton
                            :item="props.item"
                            :email="email"
                            :cellphone="cellphone"
                            :buttonClass="'financial--background table-btn'"
                            @openSlip="paySlip(props.item)"
                            :sendByEmail="sendSlipByEmailLate"
                            :sendBySms="sendSlipBySmsLate"
                          >
                            <template v-slot:tooltip>
                              <v-tooltip
                                z-index="99"
                                top
                                color="grey lighten-3"
                                max-width="300"
                              >
                                <span class="tooltip__text no-print">{{
                                  latePaymentSlipTooltip
                                }}</span>
                                <span slot="activator">
                                  <i
                                    class="bexsicon-info tooltip__icon indelay-slips-tooltip"
                                  />
                                </span>
                              </v-tooltip>
                            </template>
                          </PaymentButton>
                        </td>
                      </template>
                    </table-stepper>
                    <template v-else>
                      <empty-state-card icon="alert">
                        <div slot="message">
                          <p class="waiting-state__title">
                            <span>
                              <b>
                                Estamos aguardando o pagamento do boleto gerado
                                {{
                                  solicitations[contract.id]
                                    ? ' com vencimento no dia ' +
                                      formatDate(
                                        solicitations[contract.id]
                                          .expirationDate
                                      )
                                    : ''
                                }}.
                              </b>
                            </span>
                          </p>
                          <p class="waiting-state__text">
                            <span>{{
                              $t('pages.paymentSlip.waitingMessage')
                            }}</span>
                          </p>
                          <p class="waiting-state__text">
                            <router-link
                              v-if="ticketCrmEnabled"
                              class="financial--color font-weight-bold"
                              :to="{ name: 'ticketForm' }"
                              tag="a"
                            >
                              <u>{{ $t('pages.paymentSlip.supportLink') }}</u>
                            </router-link>
                          </p>
                        </div>
                      </empty-state-card>
                    </template>
                  </div>
                </v-card-text>
              </v-card>
            </span>
          </template>
        </div>
      </v-flex>
    </v-layout>
  </module-page>
</template>

<script>
import bus from '@/utils/bus';
import enums from '@/utils/enums';
import ModulePage from '@/components/layout/Page';
import ScreenLoading from '@/components/loaders/ScreenLoading';
import TableStepper from '@/components/financial/TableStepper';
import EmptyStateCard from '@/components/layout/EmptyStateCard';
import PaymentButton from '@/components/financial/PaymentButton';
import latePaymentSlipMixin from '@/mixins/modules/latePaymentSlip';
import notificationTypes from '@/utils/notificationTypes';
import getSlipUrl from '@/services/getSlipUrl';
import {
  APP,
  CONFIG,
  NOTIFICATIONS,
  ROLES,
  SOLICITATE_TYPE,
  USER,
  PARCEL_TYPES,
  TICKET_CRM,
} from '../../utils/constants';

export default {
  name: 'toExpirePaymentSlip',
  components: {
    ModulePage,
    ScreenLoading,
    TableStepper,
    EmptyStateCard,
    PaymentButton,
  },
  mixins: [latePaymentSlipMixin],
  computed: {
    imobmeUser() {
      return this.$store.getters[USER.GET_IMOBME_DATA];
    },
    ticketCrmEnabled() {
      return this.$store.getters[TICKET_CRM.GET_ENABLED];
    },
    hasSolicitationsInProgress() {
      return this.selectedUnit.contracts.find(
        (o, i) => this.solicitations[o.id]
      );
    },
    config() {
      return this.$store.getters[CONFIG.GET];
    },
    debitBlock() {
      return (
        this.selectedUnit.contracts.some((contract) => contract.debitBlock) ||
        false
      );
    },
    allowedContracts() {
      const { LATE_SLIPS } = enums.financialModules;
      return this.getAllowedContracts(LATE_SLIPS, this.selectedUnit.contracts);
    },
    latePaymentSlipTooltip() {
      return (this.$store.getters[CONFIG.GET] || { texts: {} }).texts
        .latePaymentSlipTooltip;
    },
    slipTimeoutHours() {
      return this.$store.getters[CONFIG.GET_SLIP_TIMEOUT_HOURS];
    },
  },
  data() {
    return {
      slips: {},
      parcelTypesNotValid: false,
      pageParams: this.$store.getters[APP.PAGES].paymentSlip,
      loadingSolicitation: false,
      description: '',
      selectedStep: {},
      solicitations: {},
      selected: {},
      solicitationErrors: {},
      hasLateSlips: false,
      error: false,
      loadingItems: false,
      systemDischarge: {},
      headers: [
        {
          text: this.$t('pages.paymentSlip.expirationDate'),
          value: 'expirationDate',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('pages.paymentSlip.discountedValue'),
          value: 'discountedValue',
          align: 'center',
          sortable: false,
        },
        { text: '', value: '', align: 'center', sortable: false },
      ],
      firstStepHeaders: [
        {
          text: this.$t('pages.paymentSlip.expirationDate'),
          value: 'expirationDate',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('pages.paymentSlip.discountedValue'),
          value: 'discountedValue',
          align: 'center',
          sortable: false,
          required: true,
        },
        { text: '', value: '', align: 'center', sortable: false },
      ],
      mobileHeaders: [
        {
          text: this.$t('pages.paymentSlip.expirationDate'),
          value: 'expirationDate',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('pages.paymentSlip.discountedValue'),
          value: 'discountedValue',
          align: 'center',
          sortable: false,
          required: true,
        },
      ],
      firstStepMobileHeaders: [
        {
          text: this.$t('pages.paymentSlip.expirationDate'),
          value: 'expirationDate',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('pages.paymentSlip.discountedValue'),
          value: 'discountedValue',
          align: 'center',
          sortable: false,
          required: true,
        },
      ],
      email: '',
      cellphone: {
        countryCode: '+55',
        areaCode: '',
        number: '',
      },
    };
  },
  created() {
    bus.$on('unit:change', this.setItems);
    bus.$on('unit:update', this.setItems);

    this.email = this.user.email;
    if (this.imobmeUser && this.imobmeUser.cellphone) {
      const { number, areaCode, countryCode } = this.imobmeUser.cellphone;
      this.cellphone = { number, areaCode, countryCode: countryCode || '+55' };
    }

    this.description = this.pageParams.texts.inDelayDescription;

    this.setItems();
  },
  beforeDestroy() {
    bus.$off('unit:change', this.setItems);
    bus.$off('unit:update', this.setItems);
  },
  methods: {
    setItems(unitObj = null) {
      this.formatSelecteds();
      this.getItems();
    },

    formatSelecteds() {
      for (const { id } of this.selectedUnit.contracts) {
        this.selectedStep[id] = '1';
      }
    },

    paySlip(slip) {
      if (slip.slipUrl.hash) {
        window.open(getSlipUrl(slip.slipUrl.hash));
      } else {
        window.open(slip.slipUrl);
      }

      const notification = {
        id: slip._id,
        type: notificationTypes.LATE_SLIPS,
      };
      this.$store.dispatch(NOTIFICATIONS.SAVE_VISUALIZED, {
        ctx: this,
        notification,
      });
      const contract = this.selectedUnit.contracts.find(
        ({ id }) => id === slip.contractId
      );
      const traceInfo = {
        contractId: slip.contractId,
        contractType: contract.type,
        detachedType: this.getContractTitle(contract),
        paymentTotal: slip.paymentTotal,
        solicitationCode: slip.solicitationCode,
        expirationDate: slip.expirationDate,
        parcels: slip.parcels,
        url: slip.slipUrl,
      };
      const traceAction = enums.logTraceActions.latePaymentSlipDownload;
      this.createTrace(traceAction, traceInfo);
    },

    async solicitateSlip(contractId) {
      if (this.user.userRole !== ROLES.CLIENT_ROLE) return;
      if (this.loadingSolicitation) return;
      try {
        this.loadingSolicitation = true;

        const parcels = this.selected[contractId];

        if (!parcels || parcels.length === 0) return;

        const contract = this.selectedUnit.contracts.find(
          ({ id }) => id === contractId
        );

        const body = {
          contractId,
          contractType: contract.type,
          productSku: this.selectedUnit.sku,
          requestUser: {
            username: this.user.username,
            fullName: this.user.fullName,
            email: this.user.email,
          },
          parcels: parcels.map(
            ({
              noChargeValue,
              discountedValue,
              parcelCode,
              serieId,
              serieCode,
              id,
              expirationDate,
              spe,
            }) => {
              return {
                noChargeValue,
                discountedValue,
                parcelCode,
                serieId,
                serieCode,
                id,
                expirationDate,
                spe,
              };
            }
          ),
          solicitationType: SOLICITATE_TYPE.LATE,
        };

        const result = await this.requestService(
          `${process.env.PAYMENT_SLIP_API_URL}/save`,
          'POST',
          {
            data: body,
            localErrorHandling: true,
            retries: 0,
          }
        );

        if (result) {
          this.selectedStep[contractId] = '2';

          this.$forceUpdate();

          const traceAction = enums.logTraceActions.latePaymentSlipSolicitation;
          const traceInfo = {
            contractId: result.contractId,
            contractType: contract.type,
            detachedType: this.getContractTitle(contract),
            paymentTotal: result.paymentTotal,
            solicitationCode: result.solicitationCode,
            expirationDate: result.expirationDate,
            parcels,
          };
          this.createTrace(traceAction, traceInfo);
        }
      } catch (e) {
        console.error({ ...e });

        if (e.status === 500) {
          this.error = true;
        }
      } finally {
        this.loadingSolicitation = false;
      }
    },

    async getItems() {
      try {
        this.error = false;
        this.loadingItems = true;

        const contractsToGetLateSlips = [...this.allowedContracts];

        let solicitations = [];
        if (contractsToGetLateSlips.length > 0) {
          let promises = [
            this.getLateSolicitations(contractsToGetLateSlips),
            this.getLatePaymentSlips(contractsToGetLateSlips),
          ];
          let [solicitationsResult] = await Promise.all(promises);
          solicitations = solicitationsResult;
        }

        for (const solicitation of solicitations) {
          let hasSomethingToShow = false;

          if (solicitation.systemDischarge) {
            this.solicitations[solicitation.contractId] =
              solicitation.items[0] || null;
            this.systemDischarge[solicitation.contractId] = true;

            hasSomethingToShow = true;
          } else if (solicitation.inProgress || solicitation.error) {
            this.selectedStep[solicitation.contractId] = '2';
            this.solicitations[solicitation.contractId] =
              solicitation.items[0] || null;
            this.solicitationErrors[solicitation.contractId] =
              solicitation.error;

            hasSomethingToShow = true;
          } else if (solicitation.ready) {
            // Add barcode into parcel
            for (const item of solicitation.items) {
              item.ready = true;
              // item.barcode = null;
              for (const parcel of item.parcels) {
                const { barcode } =
                  this.slips[item.contractId].find(
                    (s) =>
                      s.serieId === parcel.serieId &&
                      s.parcelCode === parcel.parcelCode
                  ) || {};
                if (!item.barcode && barcode) {
                  item.barcode = barcode;
                }
              }
            }

            this.solicitations[solicitation.contractId] = solicitation.items;
            this.selectedStep[solicitation.contractId] = '3';

            hasSomethingToShow = true;
          }

          if (
            hasSomethingToShow &&
            this.solicitations[solicitation.contractId]
          ) {
            const contractIndex = contractsToGetLateSlips.findIndex(
              (o) => o.id === solicitation.contractId
            );
            if (contractIndex !== -1)
              contractsToGetLateSlips.splice(contractIndex, 1);
          }
        }

        this.$forceUpdate();
      } catch (err) {
        this.error = true;
      } finally {
        this.loadingItems = false;
      }
    },

    async getLatePaymentSlips(contractsToRequest) {
      try {
        const promises = [];
        const url = process.env.LATE_PAYMENT_SLIPS_API_URL;

        this.hasLateSlips = false;

        let loopContracts = (contracts, action) => {
          for (const contract of contracts) {
            action(contract);
          }
        };

        loopContracts(contractsToRequest, (contract) => {
          const body = {
            contractId: contract.id,
            contractType: contract.type,
          };
          this.slips[contract.id] = null;
          promises.push(
            this.requestService(url, 'GET', {
              params: body,
              localErrorHandling: true,
            }).then((res) => {
              const contractId = contract.id;
              this.slips[contractId] = [];
              if (res && res.items.length > 0) {
                const parcels = res.items.map((o) => ({ contractId, ...o }));
                this.slips[contractId].push(...parcels);
                this.slips = { ...this.slips };
                if (!this.hasLateSlips) this.hasLateSlips = true;
                this.loadingItems = false;
              }
              return res;
            })
          );
        });

        await Promise.all(promises);

        loopContracts(contractsToRequest, (contract) => {
          let index = this.slips[contract.id].findIndex(
            (slip) => slip.type === PARCEL_TYPES.proSolutoPos
          );

          if (index > -1) {
            let result = this.slips[contract.id].filter(
              (slip) => slip.type != PARCEL_TYPES.proSolutoPos
            );

            if (result.length === 0) {
              this.parcelTypesNotValid = true;
            } else {
              this.slips[contract.id] = result;
            }
          }
        });
      } catch (err) {
        throw err;
      }
    },
  },
};
</script>

<style lang="scss">
@import '../../assets/scss/breakpoint';

.waiting-state {
  &__title {
    margin: 0;
    font-weight: var(--font-weight);
  }
  &__text {
    margin: 0;
    font-size: 11px;
  }
}

.indelay-slips-tooltip {
  padding: 12px 0;
}

.table-stepper-container {
  padding: 16px;

  @include breakpoint(mobile) {
    padding: 0px;
  }
}

.payment-slip-in-delay {
  &__description {
    font-size: 12px;
    padding-bottom: 10px;
    color: var(--label-color);
  }
  &__febraban {
    font-size: var(--payment-slip-in-size);
    padding-bottom: 10px;
    color: var(--payment-slip-in-color);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/financial/LatePaymentSlip.vue